import React, { useState, useEffect, JSX } from 'react' 
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { injectIntl, FormattedMessage, IntlShape, useIntl } from 'react-intl';
import { DataGrid, Column, Export, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, HeaderFilter, Selection, Sorting, DataGridTypes } from 'devextreme-react/data-grid';
import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import moment from 'moment'
import {APIGetLoggersModel, BuildApiGetLoggers } from '../../models/APIGetLoggersModel'
import { Chip, useTheme, Menu, MenuItem, Button } from '@mui/material';
import { isLCLLogger } from 'variables/chariotProductIds';
import { Redirect } from "react-router-dom";
import Loader from '../../Utils/Loader/NewLoader2025'
import {useTabletContext } from '../../Context/ContextProvider'
interface RedirectProps {
    serial: number | undefined;
}

const NonReportingDevicesListMobile: React.FC = () => {
    //hooks
    const intl: IntlShape = useIntl()
    const theme = useTheme()
    const isTablet = useTabletContext()
    //state
    const [timeframe, setTimeframe] = useState<string | null>(window.sessionStorage.getItem("inactiveTimeframe")  && window.sessionStorage.getItem("inactiveTimeframe") != "null" ? window.sessionStorage.getItem("inactiveTimeframe") : "24 Hours",)
    const [deviceData, setDeviceData] = useState<Array<APIGetLoggersModel>>([])
    const [redirect, setRedirect] = useState<boolean>(false)
    const [redirectPath, setRedirectPath] = useState<string>("string")
    const [redirectProps, setRedirectProps] = useState<RedirectProps | undefined>()
    const [loading, setLoading] = useState<boolean>(true)
    //useffects
    useEffect(() => {reloadData()}, [])


    const reloadData = (): void => {
        let userTimeFrame = 1
        if (timeframe === "14 Days") {
            userTimeFrame = 14
        } else if (timeframe === "7 Days") {
            userTimeFrame = 7
        } else if (timeframe === "4 Days") {
            userTimeFrame = 4
        }
        CallGetAPI(CreateUrl('/api/aquaguard/GetNonReportingLoggers?companyId=' + sessionStorage.getItem('companyId') + '&filterGroup=' + sessionStorage.getItem('filterGroupId') + "&startDate=" + moment().subtract(userTimeFrame, 'days').format("YYYY-MM-DD HH:mm:ss") + "&endDate=" + moment().format("YYYY-MM-DD HH:mm:ss")), {})
            .then(data => {

                const deviceDataTemp: APIGetLoggersModel[] = []
                data.forEach(d => {
                    
                    deviceDataTemp.push(BuildApiGetLoggers(d))
                })
                setDeviceData(deviceDataTemp)
                setLoading(false)
            })
            .catch((err) => {
                console.error(err)

            })
    }

    const serialColumnTemplate = (item: DataGridTypes.ColumnCellTemplateData): JSX.Element => {
        console.log(item)
        
        return (<Chip
            label={item.data.Serial}
            sx={{ backgroundColor: theme.palette.grey.main, color: theme.palette.grey.contrastText }}
            onClick={(): void => deviceOverviewClick(item.data.Serial, item.data.Model)}
        //onContextMenu={(e): void => handleContextMenu(e, item.data.serial, item.data.model)}
        />)
    }

    const dateColumnCustomizeText = (data: DataGridTypes.ColumnCellTemplateData): JSX.Element => {
        return <div style={{ marginTop: "7px" }}>{moment(data.data.LastConnected).format("DD MMM YYYY HH:mm")}</div>
    }

    const deviceOverviewClick = (serial: number | undefined, model: string | undefined): void => {
        console.log(serial, model)
        setRedirect(true)
        setRedirectPath(!isLCLLogger(model) ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail')
        setRedirectProps({ serial: serial })
    }

    const renderOverviewButton = (data: DataGridTypes.ColumnCellTemplateData): JSX.Element => {
        return <Button color="secondary" variant="contained" onClick={():void => deviceOverviewClick(data.data.Serial, data.data.Model) }><FormattedMessage id='Overview' /></Button>
    }



    return (<>
        {loading ? <div style={{
            position: 'relative', left: 'Calc(50% - 100px)', minHeight: 200
        }}>
            <Loader color={undefined} />
        </div> : 
        !redirect ? (<div>
            <Card>
                <CardHeader color="primary">
                    <h4 style={{ textAlign: "center" }}>{intl.formatMessage({ id: "Active devices with no connections, based on user defined time period" })}</h4>
                </CardHeader>
                    <CardBody>{console.log(deviceData) }
                    <DataGrid
                        dataSource={deviceData}
                        scrolling={{
                            mode: 'standard',
                            useNative: false
                        }}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                    >
                        <FilterRow visible={true} />
                            <HeaderFilter visible={true} search={{ enabled: true}} />
                            <Column dataField="Serial" dataType="string" cellRender={(data): JSX.Element => serialColumnTemplate(data)} caption={intl.formatMessage({ id: "Serial" })} width={77} />
                            {isTablet && <Column dataField="Site" caption={intl.formatMessage({ id: "Device Name" })} />}
                            {isTablet && <Column dataField="SiteName" caption={intl.formatMessage({ id: "Site Ref" })} />}
                            {isTablet && <Column dataField="SiteNameUserFriendly" caption={intl.formatMessage({ id: "Site Name" })} />}
                        <Column dataField="lastConnected" cellRender={(data): JSX.Element => dateColumnCustomizeText(data)} caption={intl.formatMessage({ id: "Last Connected" })} allowHeaderFiltering={true} format="shortDate" />
                        <Column cellRender={(data): JSX.Element => renderOverviewButton(data)} caption={intl.formatMessage({ id: "Details" })} />
                    </DataGrid>
                </CardBody>
            </Card>
        </div>) :
            <Redirect push to={{
                pathname: redirectPath,
                state: redirectProps
            }} />}
    </>)
}

export default NonReportingDevicesListMobile